import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import { change } from 'redux-form';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import TextFieldComponent from './TextFieldComponent';

import { BUILDING_GUIDE_FORM } from '../BuildingGuide/constants';

const MultipleTextFields = (props) => {
  const { t } = useTransl();
  const { values = [{ title: '', body: '' }], isCreate, isWiFiLayout } = props;

  const dispatch = useDispatch();

  const additionalLabelsValidation =
    isWiFiLayout && values?.length < 2
      ? [...values, { title: '', body: '' }]
      : values !== null
      ? values
      : [{ title: '', body: '' }];

  const [additionalFields, setAdditionalFields] = useState(
    isCreate ? [{ title: '', body: '' }] : additionalLabelsValidation,
  );

  const addNewField = () => {
    setAdditionalFields([...additionalFields, { title: '', body: '' }]);
  };

  const handleRemoveField = (index) => {
    const filteredFields = additionalFields.filter((_, i) => i !== index);
    setAdditionalFields(filteredFields);
  };

  const addButton = (
    <Box display="flex" justifyContent="flex-end" onClick={addNewField}>
      <AddCircleOutlineIcon />
    </Box>
  );

  const onChange = (e, field, idx) => {
    const updatedFields = [...additionalFields];
    updatedFields[idx][field] = e.target.value;
    setAdditionalFields(updatedFields);
  };

  useEffect(() => {
    dispatch(change(BUILDING_GUIDE_FORM, 'additionalLabels', additionalFields));
  }, [additionalFields]);

  useEffect(() => {
    setAdditionalFields(additionalLabelsValidation);
  }, [isWiFiLayout]);

  return (
    <Box>
      {addButton}
      {additionalFields?.map((item, index) => (
        <Box key={index} display="flex" gap="1rem" width="100%">
          <Box display="flex" flexDirection="column" width="100%">
            <Typography>{t('title.title')}</Typography>
            <TextFieldComponent
              input={{
                value: item.title || '',
                onChange: (e) => onChange(e, 'title', index),
              }}
              meta={{}}
            />
          </Box>
          <Box display="flex" flexDirection="column" width="100%">
            <Typography>{t('title.body')}</Typography>
            <TextFieldComponent
              input={{
                value: item.body || '',
                onChange: (e) => onChange(e, 'body', index),
              }}
              meta={{}}
            />
          </Box>

          <Box
            display="flex"
            alignItems="center"
            onClick={() => handleRemoveField(index)}
          >
            <DeleteIcon />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

MultipleTextFields.propTypes = {
  values: PropTypes.instanceOf(Array),
  isCreate: PropTypes.bool,
  isWiFiLayout: PropTypes.bool,
};

export default MultipleTextFields;
